<template>
	<search-list ref="sl" :where="where" :order="order" :attributes="attributes" api-path="/topOffer/list" notSearchAll :searchKeys="searchKeys">
		<div class="search-condition">
			<div class="row">
				<mm-lc title="Period">
					<mm-date-range v-model="where.time"/>
				</mm-lc>
				<mm-lc title="Adv">
					<mm-adv-select v-model="where.adv_id" multiple />
				</mm-lc>
				<mm-lc title="Channel">
					<mm-channel-select v-model="where.channel_id" multiple />
				</mm-lc>
				<mm-lc title="Status">
					<mm-offer-status v-model="where.status" multiple />
				</mm-lc>
				<mm-lc title="Country">
					<mm-offer-geos v-model="where.geo" multiple />
				</mm-lc>
				<mm-lc title="Platform">
					<mm-offer-platform v-model="where.platform"/>
				</mm-lc>

			</div>
		</div>

		<el-button slot="actions" type="success" class="el-icon-document-add" @click="create" />

		<mm-table slot="dataTable" slot-scope="res" :res="res">
			<el-table-column type="expand" fixed="left">
				<template slot-scope="props">
					<el-table :data="props.row.sub" style="width: 100%" :row-class-name="subTableRow" :header-cell-class-name="subTableHeader">
						<el-table-column label="Adv Name">
							<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" v-if="sp.row.adv_id!==0" row_type="adv" />
						</el-table-column>
						<el-table-column label="Offer Id" prop="offerid" width="100"/>
						<el-table-column label="Offer Name" prop="offer_name" width="140">
							<mm-get-detail slot-scope="sp" row_type="offer" :row_id="sp.row.offerid" :row_name="sp.row.offer_name" />
						</el-table-column>
						<el-table-column label="Caps" width="130" prop="daily_cap" sortable/>
						<el-table-column label="Status" prop="status">
							<span slot-scope="sp" :class="'status-'+sp.row.status.trim()">{{sp.row.status.toUpperCase()}}</span>
						</el-table-column>
						<el-table-column label="Clicks" width="130" prop="click" sortable/>
						<el-table-column label="Conv." width="130" prop="conv" sortable/>
						<el-table-column label="Deduct Conv." prop="ded_conv" sortable/>
						<el-table-column label="Sent  Conv." prop="sent_conv" sortable/>
						<el-table-column label="CVR" prop="cvr" sortable/>
						<el-table-column label="Sent CVR" prop="sent_cvr" sortable/>
						<el-table-column label="Avg. Price" prop="avg_price" sortable/>
						<el-table-column label="Avg. Payout" prop="avg_payout" sortable/>
						<el-table-column label="Revenue" prop="rev" sortable/>
						<el-table-column label="Cost($)" prop="cost" sortable/>
						<el-table-column label="Profit" prop="profit" sortable/>
						<el-table-column label="ROI" prop="roi" sortable/>
						<el-table-column label="Deduct Rate($)" prop="ded_rate" sortable/>
						<el-table-column label="ECPC" prop="ecpc" sortable/>
					</el-table>
				</template>
			</el-table-column>
			<el-table-column label="Adv Name" fixed="left">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.adv_name" :row_id="sp.row.adv_id" v-if="sp.row.adv_id!==0" row_type="adv" />
			</el-table-column>
			<el-table-column label="Channel Name" fixed="left">
				<mm-get-detail slot-scope="sp" :row_name="sp.row.channel_name" :row_id="sp.row.channel_id" v-if="sp.row.channel_id!==0" row_type='channel' />
			</el-table-column>
			<el-table-column label="Package Name" prop="package_id" width="92" fixed="left"/>
			<el-table-column label="Regions" prop="geo" fixed="left" />
			<el-table-column label="Price" prop="price" width="75" fixed="left"/>
			<el-table-column label="Total Offers" width="70" fixed="left">
				<template slot-scope="props">
					<span>{{ props.row.sub.length }}</span>
				</template>
			</el-table-column>
			<el-table-column label="Clicks" prop="click" width="90" sortable/>
			<el-table-column label="Conv." prop="conv" width="90" sortable/>
			<el-table-column label="Deduct Conv." prop="ded_conv" width="87" sortable/>
			<el-table-column label="Sent  Conv." prop="sent_conv" width="77" sortable/>
			<el-table-column label="CVR" prop="cvr"/>
			<el-table-column label="Sent CVR" width="101" prop="sent_cvr"/>
			<el-table-column label="Avg. Price" width="121" prop="avg_price" sortable/>
			<el-table-column label="Avg. Payout" width="135" prop="avg_payout" sortable/>
			<el-table-column label="Revenue" prop="rev" width="110" fixed="right" sortable/>
			<el-table-column label="Cost($)" prop="cost" width="110" fixed="right" sortable/>
			<el-table-column label="Profit" prop="profit" width="110" fixed="right" sortable/>
			<el-table-column label="ROI" prop="roi" />
			<el-table-column label="Deduct Rate($)" prop="ded_rate" />
			<el-table-column label="ECPC" prop="ecpc"/>
			<el-table-column label="Status" prop="status">
				<span slot-scope="sp" :class="'status-'+sp.row.status.trim()">{{sp.row.status.toUpperCase()}}</span>
			</el-table-column>
			<el-table-column label="action">
				<template slot-scope="sp">
					<el-button @click.native="edit(sp.row)">Edit</el-button>
				</template>
			</el-table-column>
		</mm-table>
	</search-list>
</template>

<script>
export default {
	data() {
		const searchKeys = {
			package_id: { label: "Package Id" }
		};
		return {
			where: {
				status: { $in: [ 'active' ] }
			},
			order: [['create_at',-1]],
			attributes:[],
			camp: {},
			searchKeys,
			selected: [],
			showEditCamp: false
		};
	},
	methods: {
		create() {
			window.open("/topOfferEdit");
		},
		edit(row) {
			window.open(`/topOfferEdit?id=${row._id}`);
		},
		subTableRow({row, rowIndex}) {
			return 'sub-row-color';
		},
		subTableHeader({row, rowIndex}) {
			return 'sub-table-header';
		}
	}
};
</script>

<style scoped>
.edit-camp {
	width: 400px;
	height: 500px;
}
.el-form-item {
	width: 500px;
}
.search-condition {
	display: flex;
	flex-direction: column;
}
.row {
	display: flex;
	flex-direction: row;
	margin-bottom: 5px;

}
</style>

<style>
/* sub table */
.sub-row-color {
	background: #ebe8e8 !important;
}
.sub-table-header {
    background: #d2d2d2 !important;
    color: black;
}
</style>